const styles = theme => ({
  appBarRoot: {
    boxShadow:
      "0px 0px 0px -1px rgba(0, 0, 0, 0.1), 0px 2px 16px 0px rgba(0, 0, 0, 0.1), 0px 0px 2px 0px rgba(0, 0, 0, 0.1)",
    zIndex: 2,
    backgroundColor: theme.palette.primary.light,
  },
  tabBarRoot: {
    boxShadow:
      "0px 0px 0px -1px rgba(0, 0, 0, 0.1), 0px 2px 16px 0px rgba(0, 0, 0, 0.1), 0px 0px 2px 0px rgba(0, 0, 0, 0.1)",
    zIndex: 2,
    backgroundColor: "#023e90",
  },
  toolbarRoot: {},
  menuButton: {
    marginLeft: -12,
    marginRight: 20,
    color: "#000000",
  },
  logo: {
    maxHeight: 40,
    marginRight: theme.spacing(4),
  },
  switch: {
    cursor: "pointer",
    display: "flex",
    alignItems: "center",
  },
  switchIcon: {
    marginRight: theme.spacing(2),
  },
  switchPlace: {
    display: "flex",
    alignItems: "center",
  },
  placeName: {
    fontSize: 10,
  },
  placeIcon: {
    width: "0.7em",
    marginLeft: theme.spacing(1),
  },
  rightArea: {
    display: "flex",
    alignItems: "center",
    flexGrow: 1,
    justifyContent: "flex-end",
  },
  chip: {
    backgroundColor: ["transparent", "!important"],
    color: "#fff",
    marginRight: theme.spacing(4),
    "&:hover": {
      backgroundColor: "transparent",
    },
  },
  chipDeleteIcon: {
    color: "#fff",
    "&:hover": {
      color: "#fff",
    },
  },
  textField: {
    border: "none",
    padding: 12,
    borderRadius: 2,
    marginRight: theme.spacing(4),
    outline: "none",
  },
  drawer: {
    width: 300,
  },
  popperClose: {
    pointerEvents: "none",
  },
  userDropDownPaper: {
    minWidth: 200,
  },
  media: {
    height: 0,
    paddingTop: "56.25%", // 16:9
    position: "relative",
  },
  mediaContent: {
    position: "absolute",
    bottom: theme.spacing(1.5),
    left: theme.spacing(2),
    color: "#fff",
  },
  cardHeadline: {
    fontSize: "1.3em",
    display: "inline-block",
    whiteSpace: "nowrap",
    overflow: "hidden",
    width: "100%",
    textOverflow: "ellipsis",
    marginBottom: 0,
  },
  nestedListItem: {
    background: theme.palette.background.default,
  },
  currentCompany: {
    background: theme.palette.primary.dark,
    color: "#FFFFFF",
    "&:hover": {
      background: theme.palette.primary.dark,
    },
  },
  currentCompanyIcon: {
    color: "#FFFFFF",
  },
  currentCompanyText: {
    color: "#FFFFFF",
  },
  listItemIcon: {
    color: theme.palette.primary.dark,
  },
  flex: {
    display: "flex",
    flexDirection: "column",
  },
  menuContent: {
    flexGrow: 1,
  },
  logout: {},
  appTitle: {
    fontFamily: "oswald",
    fontWeight: 400,
    color: "#000000",
    [theme.breakpoints.down("sm")]: {
      fontSize: "1.2rem",
    },
  },
})

export default styles
